export default "__VITE_ASSET__DZETGpk7__"